import { render } from "./ClientShadowOverlay.vue?vue&type=template&id=56efd118"
import script from "./ClientShadowOverlay.vue?vue&type=script&lang=js"
export * from "./ClientShadowOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__